import React, {useMemo} from "react";
import {Dropdown, DropdownItem} from "../../components";
import {useHistory, useParams} from "react-router-dom";
import {RouteWithId} from "../../routes/types";
import {useAppSelector} from "../../store/hooks";
import {selectHasStateOfResidencyStrategy} from "../WealthPlanOptimizerSlice";
import useProfileEditableState from "../../hooks/useProfileEditableState";
import {useAnalyticsTrackers} from "../../utils/useAnalyticsTrackers";

type AddStrategyButtonDropdownProps = {
    className?: string,
}

const AddStrategyButtonDropdown: React.FC<AddStrategyButtonDropdownProps> = ({
                                                                                 className
                                                                             }) => {
    const history = useHistory();
    const {id} = useParams<RouteWithId>();
    const {isProfileWithProposalsOrArchived} = useProfileEditableState();
    const hasStateOfResidencyStrategy = useAppSelector(selectHasStateOfResidencyStrategy);

    const {page} = useAnalyticsTrackers("enableWPOptimizerGoogleAnalytics");

    const dropdownItemArray = useMemo(() => {
        return [

            {
                itemText: "2-Year GRAT",
                value: "2-Year GRAT",
                onClick: () => {
                    page(`Two_Year_GRAT_Click`);
                    history.push(`/Profile/${id}/ClientProfile/WealthPlanOptimizer/AddTwoYearGRAT`);
                },
                disabled: false
            },
            {
                itemText: "5-Year GRAT",
                value: "5-Year GRAT",
                onClick: () => {
                    page(`Five_Year_GRAT_Click`);
                    history.push(`/Profile/${id}/ClientProfile/WealthPlanOptimizer/AddFiveYearGRAT`);
                },
                disabled: false
            },
            {
                itemText: "Annual Gifting",
                value: "Annual Gifting",
                onClick: () => {
                    page(`Annual_Gifting_Click`);
                    history.push(`/Profile/${id}/ClientProfile/WealthPlanOptimizer/AddAnnualGifting`);
                },
                disabled: false
            },
            {
                itemText: "Gift to Grantor Trust",
                value: "Gift to Grantor Trust",
                onClick: () => {
                    page(`Gift_To_Grantor_Trust_Click`);
                    history.push(`/Profile/${id}/ClientProfile/WealthPlanOptimizer/AddGiftToGrantorTrust`);
                },
                disabled: false
            },
            {
                itemText: "Rolling GRAT",
                value: "Rolling GRAT",
                onClick: () => {
                    page(`Rolling_GRAT_Click`);
                    history.push(`/Profile/${id}/ClientProfile/WealthPlanOptimizer/AddRollingGRAT`);
                },
                disabled: false
            },

            {
                itemText: "State of Residency (Estate Tax)",
                value: "State of Residency (Estate Tax)",
                onClick: () => {
                    page(`State_Of_Residency_Click`);
                    history.push(`/Profile/${id}/ClientProfile/WealthPlanOptimizer/AddStateOfResidency`);
                },
                disabled: hasStateOfResidencyStrategy
            }
        ];
    }, [id, hasStateOfResidencyStrategy]);

    return <Dropdown
        className={className}
        alignRight
        buttonIcon="left"
        buttonKind="primary"
        dropdownKind="menu"
        defaultText="Add Strategy"
        iconNameOpen="add"
        iconNameClose="add"
        panelWidth={245}
        rounded
        inverse={false}
        disabled={isProfileWithProposalsOrArchived}
    >
        {
            dropdownItemArray.map((item: any, i: number) =>
                <DropdownItem key={i}
                              itemText={item.itemText}
                              value={item.value}
                              onClick={item.onClick}
                              disabled={item.disabled}
                              style={{ display: "flex", marginRight: "auto" }}
                />)
        }
    </Dropdown>
}

export default AddStrategyButtonDropdown;
